import React, { useState, useRef } from 'react';

import { link } from '../../helpers/link';
import './DiscountProgramCategoryList.scss';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';

const { LeftArrow, RightArrow } = icons;

export default function DiscountProgramCategoryList(props) {
  const list = props.list || [];
  const listRef = useRef(null);
  const [currentPage, togglePage] = useState(1);

  const lastPage = Math.ceil(list.length / 6);

  return (
    <section id="discountProgramCategoryList">
      {props.title && <h2>{props.title}</h2>}

      <div id="discountProgramCategoryList_content">
        <ul ref={listRef}>
          {list.map((category, idx) => (
            <li className="discountProgramCategoryList_item" key={idx}>
              {link(
                <div
                  onClick={() =>
                    props.eventTrackingCodes &&
                    sendEvent(...props.eventTrackingCodes.category)
                  }
                >
                  <img src={category.imageUrl} />

                  <p>{category.name}</p>
                </div>,
                `/discount-program-category?uri=${category.uri}`
              )}
            </li>
          ))}
        </ul>

        <div>
          {currentPage !== 1 && (
            <div
              id="discountProgramCategoryList_arrow_left"
              className="discountProgramCategoryList_arrow"
              onClick={() => move('backward')}
            >
              <LeftArrow />
            </div>
          )}

          {currentPage !== lastPage && (
            <div
              id="discountProgramCategoryList_arrow_right"
              className="discountProgramCategoryList_arrow"
              onClick={() => move('forward')}
            >
              <RightArrow />
            </div>
          )}
        </div>
      </div>

      {props.showBottomLink && (
        <div className="discountProgramCategoryList_link">
          <a
            href="/alle-voordelen"
            onClick={() =>
              props.eventTrackingCodes &&
              sendEvent(...props.eventTrackingCodes.all)
            }
          >
            Bekijk alles
          </a>
        </div>
      )}
    </section>
  );

  function move(direction) {
    const isForward = direction === 'forward';

    const translateX = `${isForward ? `-${currentPage}` : `-${currentPage - 2}`}00%`;

    listRef.current.style.cssText = `
      transition-duration: .3s;
      transition-property: transform;
      transform: translateX(${translateX});
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }
}
